module.exports = __webpack_public_path__ + "static/img/iconmenu09.313896f9.svg";